/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class VerificationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @deprecated
     * [REMOVED] Confirm phone verification via Firebase
     * This endpoint has been removed. Use POST /users/{userId}/verification/phone/send and POST /users/{userId}/verification/phone/verify instead.
     * @returns void
     * @throws ApiError
     */
    public verificationControllerConfirmPhone(): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/verification/phone/confirm',
            errors: {
                401: `Unauthorized.`,
                410: `Gone. This endpoint has been removed. Use the OTP-based phone verification flow instead.`,
            },
        });
    }
}
